(() => {
  // FWO i18n: T() shows Spanish on /es (snippets/fwo-i18n.liquid). Only on-screen text — never values sent to the Hub.
  const T = (s) => (window.FwoT ? window.FwoT(s) : s);
  // ====== CONFIG (EDIT THESE) ======
  // Quote intake backend: the Admin Hub Worker (firewood-quote-dashboard). Before
  // 2026-10 this was the AWS Lambda "https://toa4sbwsau2dnyllth5jmz3are0uolun.lambda-url.us-east-1.on.aws/"
  // — swap it back here to roll back during the migration overlap.
  const QUOTE_API_URL = "https://firewood-quote-dashboard.firewoodoven.workers.dev/api/quotes/capture";
  const SUPPORT_PHONE = "(787) 603-1526";

  // Shopify product search endpoint (no app needed)
  const SUGGEST_URL = "/search/suggest.json";

  // ====== HELPERS ======
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  window.__fwqDocClickBound = window.__fwqDocClickBound || false;

  if (!window.__fwqDocClickBound) {
  window.__fwqDocClickBound = true;

  document.addEventListener("click", (e) => {
    const appEl = document.getElementById("fw-quote-app");
    if (!appEl) return;

    // only react to clicks inside the quote app
    if (!appEl.contains(e.target)) return;

    const searchEl = document.getElementById("fwq_product_search");
    const resultsEl = document.getElementById("fwq_results");
    if (!searchEl || !resultsEl) return;

    // ignore clicks on the input or inside results
    if (e.target === searchEl || resultsEl.contains(e.target)) return;

    resultsEl.style.display = "none";
    resultsEl.innerHTML = "";

  });
}


  const escapeHtml = (s = "") =>
    String(s).replace(/[&<>"']/g, (c) => ({ "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;" }[c]));

  const debounce = (fn, ms = 250) => {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  };

  // ====== PRODUCT DATA CACHE ======
  // One request per URL per page visit, shared by the prefill, search and both pop-ups,
  // and warmed ahead of the click by FwoQuoteForm.prefetch(handle) (card hover / touch,
  // assets/fwo-quote-modal.js). The product, MAM-builder and oven-options data load in
  // parallel instead of one after another.
  const fwqFetchCache = new Map();
  function fetchTextCached(url) {
    if (!fwqFetchCache.has(url)) {
      fwqFetchCache.set(url, fetch(url).then(r => (r.ok ? r.text() : null)).catch(() => null));
    }
    return fwqFetchCache.get(url);
  }
  async function fetchJsonText(url) {
    const t = await fetchTextCached(url);
    if (!t) return null;
    try { return JSON.parse(t); } catch (e) { return null; } // e.g. a ?view= template that isn't JSON
  }
  // Locale-aware (2026-10-09): on /es the product handle is the Spanish one, which only resolves under /es/.
  const ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/").replace(/\/$/, "");
  const productJsUrl = (h) => `${ROOT}/products/${encodeURIComponent(h)}.js`;
  const productViewUrl = (h, view) => `${ROOT}/products/${encodeURIComponent(h)}?view=${view}`;
  // On /es an ENGLISH handle 404s for .js (no redirect, unlike ?view= pages), which left the quote line
  // without a variant → a $0 custom line in the Hub (#D288, 2026-10-17). Fall back to the default locale.
  async function fetchProductJs(h) {
    return (await fetchJsonText(productJsUrl(h))) || (ROOT ? fetchJsonText(`/products/${encodeURIComponent(h)}.js`) : null);
  }
  // Translation-app markup (<tc>…</tc>) must never reach a quote line.
  const stripTc = (s) => String(s || "").replace(/<\/?tc>/gi, "");
  function prefetchProduct(handle) {
    if (!handle) return;
    [productJsUrl(handle), productViewUrl(handle, "mambuilder"), productViewUrl(handle, "quoteoptions")].forEach(fetchTextCached);
  }

  const getHandleFromUrl = (url = "") => {
    // expects "/products/handle" or full URL
    try {
      const u = new URL(url, window.location.origin);
      const m = u.pathname.match(/\/products\/([^\/\?]+)/);
      return m ? m[1] : "";
    } catch {
      const m = String(url).match(/\/products\/([^\/\?]+)/);
      return m ? m[1] : "";
    }
  };

  const isEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
  const normalizePhone = (p) => String(p || "").trim();

  const normalizeProduct = (p) => {
    return {
      title: p?.title || "",
      url: p?.url || "",
      image: p?.image || "",
      id: p?.id || p?.handle || p?.url || p?.title,
      vendor: p?.vendor || "",
      price: p?.price || "",
      handle: p?.handle || getHandleFromUrl(p?.url || ""),
    };
  };

  // ====== UI STATE ======
  const state = {
    step: 1,

    // Step 1 fields
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phone: "",

    // Line items (variants become separate rows)
    // { key, productId, productTitle, productUrl, productImage, variantId, variantTitle, sku, qty }
    products: [],

    // Step 2
    street: "",
    street2: "",
    city: "",
    country: "",
    region: "", // state
    zip: "",
    addressType: "", // ✅ NEW: "residential" | "commercial"


    // Variant picker UI (under the search bar)
    variantPicker: null,
    // { product: {id,title,url,image,handle}, variants:[{id,title,sku,available}], selectedIds:Set<string> }

    loading: false,
    message: null, // {type:'success'|'error', text:''}
  };

  // ====== RENDER ======
  function render(app) {
    app.innerHTML = `
      <div class="fwq-card">
        <div class="fwq-header">
          <h1 class="fwq-title">${T("Request a Quote")}</h1>
          <p class="fwq-sub">${T("Select products, add your shipping address, then review and submit. We’ll contact you shortly.")}</p>
        </div>

        <div class="fwq-steps">
          ${stepPill(1, T("Product Selection"))}
          ${stepPill(2, T("Shipping Address"))}
          ${stepPill(3, T("Review & Submit"))}
        </div>

        <div class="fwq-body">
          ${state.step === 1 ? step1() : ""}
          ${state.step === 2 ? step2() : ""}
          ${state.step === 3 ? step3() : ""}

          ${state.message ? `
            <div class="fwq-alert ${state.message.type === "success" ? "is-success" : "is-error"}">
              ${escapeHtml(state.message.text)}
            </div>
          ` : ""}
        </div>
      </div>
    `;

    bindEvents(app);
    bindRecs(app);
    refreshRecs(app);
  }

  function stepPill(n, label) {
    const active = state.step === n ? "is-active" : "";
    const done = state.step > n ? "is-done" : "";
    return `<div class="fwq-step ${active} ${done}">
      <div class="fwq-dot">${state.step > n ? "✓" : n}</div>
      <div>${escapeHtml(label)}</div>
    </div>`;
  }

  function step1() {
    return `
      <div class="fwq-grid">
        <div class="fwq-field">
          <label for="fwq_first">${T("First Name")}</label>
          <input id="fwq_first" class="fwq-input" autocomplete="given-name" value="${escapeHtml(state.firstName)}" placeholder="${T("First name")}" />
        </div>
        <div class="fwq-field">
          <label for="fwq_last">${T("Last Name")}</label>
          <input id="fwq_last" class="fwq-input" autocomplete="family-name" value="${escapeHtml(state.lastName)}" placeholder="${T("Last name")}" />
        </div>

        <div class="fwq-field">
          <label for="fwq_company">${T("Company")} <span style="font-weight:600;color:rgba(0,0,0,.55)">${T("(Optional)")}</span></label>
          <input id="fwq_company" class="fwq-input" autocomplete="organization" value="${escapeHtml(state.company)}" placeholder="${T("Company name (optional)")}" />
        </div>
        <div class="fwq-field">
          <label for="fwq_email">${T("Email")}</label>
          <input id="fwq_email" class="fwq-input" type="email" autocomplete="email" value="${escapeHtml(state.email)}" placeholder="you@email.com" />
        </div>

        <div class="fwq-field" style="grid-column:1/-1">
          <label for="fwq_phone">${T("Phone")}</label>
          <input id="fwq_phone" class="fwq-input" type="tel" autocomplete="tel" value="${escapeHtml(state.phone)}" placeholder="(555) 555-5555" />
          <div class="fwq-help">${T("We’ll use this to contact you about your quote.")}</div>
        </div>
      </div>

      <div style="height:14px"></div>

      <div class="fwq-field fwq-searchwrap">
        <label for="fwq_product_search">${T("Products")}</label>
        <input id="fwq_product_search" class="fwq-input" placeholder="${T("Search products (e.g., ALFA, mixer, peel…)")}" />
        <div class="fwq-help">${T("Click a result. If it has variants, pick the variant(s) below, then add to your quote.")}</div>
        <div id="fwq_results" class="fwq-results" style="display:none"></div>

        ${renderVariantPicker()}
      </div>

      <div class="fwq-pilllist" id="fwq_selected">
        ${state.products.length ? state.products.map(renderSelected).join("") : `
          <div class="fwq-alert">${T("No products selected yet. Search above and add a product (and variants if available).")}</div>
        `}
      </div>

      <div id="fwq_recs" class="fwq-recs-wrap">${recsHtmlFor(state.products)}</div>

      <div class="fwq-actions">
        <div></div>
        <button class="fwq-btn fwq-btn-primary" id="fwq_next_1">${T("Next Step →")}</button>
      </div>
    `;
  }

function renderVariantPicker() {
  if (!state.variantPicker) return "";

  const vp = state.variantPicker;
  const optionNames = vp.optionNames || vp.variants?.[0]?.optionNames || [];
  const variants = vp.variants || [];

  // Build possible values per option (unique)
  const valuesByOption = {};
  optionNames.forEach((name, idx) => {
    valuesByOption[name] = Array.from(
      new Set(variants.map(v => v.values?.[idx]).filter(Boolean))
    );
  });

  // Helper: does any available variant exist if we pick this value for this option?
  const isValueAvailable = (optName, optValue) => {
    const next = { ...(vp.selectedOptions || {}), [optName]: optValue };
    return variants.some(v => {
      if (v.available === false) return false;
      return optionNames.every((name, idx) => (v.values?.[idx] || "") === (next[name] || ""));
    });
  };

  const optionRows = optionNames.map((optName, idx) => {
    const current = (vp.selectedOptions || {})[optName] || "";
    const pills = (valuesByOption[optName] || []).map(val => {
      const selected = val === current;
      const disabled = !isValueAvailable(optName, val);

      return `
        <button
          type="button"
          class="fwq-swatch-pillbtn ${selected ? "is-selected" : ""} ${disabled ? "is-disabled" : ""}"
          data-opt="${escapeHtml(optName)}"
          data-val="${escapeHtml(val)}"
          ${disabled ? "disabled" : ""}>
          ${escapeHtml(val)}
        </button>
      `;
    }).join("");

    return `
      <div class="fwq-variant-option">
        <div class="fwq-variant-optionname">${escapeHtml(optName)}</div>
        <div class="fwq-swatchrow">${pills}</div>
      </div>
    `;
  }).join("");

  // Determine selected variant from selectedOptions
  const match = variants.find(v => {
    return optionNames.every((name, idx) => {
      return (v.values?.[idx] || "") === ((vp.selectedOptions || {})[name] || "");
    });
  });

  const hasSelected = !!match && match.available !== false;

  return `
    <div class="fwq-variantbox" style="margin-top:12px">
      <div class="fwq-variant-top">
        ${vp.product.image ? `<img class="fwq-variant-img" src="${escapeHtml(vp.product.image)}" alt="" onerror="this.style.display='none'" />` : ""}
        <div class="fwq-variant-meta">
          <div class="fwq-variant-for">${T("Select options for")}</div>
          <div class="fwq-variant-product">${escapeHtml(vp.product.title)}</div>
        </div>
      </div>

      ${optionRows}

      <div class="fwq-actions" style="margin-top:16px">
        <button type="button" class="fwq-btn" id="fwq_variant_cancel">${T("Cancel")}</button>
        <button type="button" class="fwq-btn fwq-btn-primary" id="fwq_variant_add" ${hasSelected ? "" : "disabled"}>
          Add to Quote
        </button>
      </div>
    </div>
  `;
}





  function renderSelected(item) {
    const subtitle = item.variantTitle ? `${item.variantTitle}` : "";

    return `
      <div class="fwq-pill" data-key="${escapeHtml(item.key)}">
        <div class="fwq-pill-left">
          <img class="fwq-mini" src="${escapeHtml(item.productImage || "")}" alt="" onerror="this.style.display='none'" />
          <div>
            <div class="fwq-pill-name">${escapeHtml(item.productTitle)}</div>
            <div class="fwq-itemmeta">
  ${subtitle ? `<div class="fwq-variant-sub">${escapeHtml(subtitle)}</div>` : ""}
  <a href="${escapeHtml(item.productUrl)}" target="_blank" rel="noopener">${T("View product")}</a>
</div>
          </div>
        </div>
        <div class="fwq-qty">
          <label style="font-weight:800">Qty</label>
          <input type="number" min="1" value="${Number(item.qty || 1)}" class="fwq-qty-input" />
          <button type="button" class="fwq-remove fwq-remove-x" aria-label="Remove ${escapeHtml(item.productTitle)}" title="Remove">&times;</button>
        </div>
      </div>
    `;
  }

  // ====== COUNTRY / STATE DROPDOWNS ======
  // Data comes from Shopify's {{ all_country_option_tags }}, rendered into
  // <template id="fwq-country-options"> by layout/theme.liquid. Option values are
  // Shopify's canonical English country names (so the Lambda's PR routing and
  // ISO-code mapping keep working); data-provinces is [[value, label], ...] and
  // is empty for countries without states (e.g. Puerto Rico). If the template is
  // missing, getCountries() returns [] and step 2 falls back to free-text inputs.
  const PINNED_COUNTRIES = ["United States", "Puerto Rico"];
  let countryCache = null;

  function getCountries() {
    if (countryCache) return countryCache;
    const tpl = document.getElementById("fwq-country-options");
    const opts = tpl ? Array.from(tpl.content.querySelectorAll("option")) : [];
    const seen = new Set();
    countryCache = [];
    for (const o of opts) {
      const name = (o.value || "").trim();
      if (!name || name === "---" || seen.has(name)) continue;
      seen.add(name);
      let provinces = [];
      try { provinces = JSON.parse(o.getAttribute("data-provinces") || "[]"); } catch { provinces = []; }
      countryCache.push({ name, label: o.textContent.trim() || name, provinces });
    }
    // Shopify lists Puerto Rico only as a US *state*, not a country. Make it a
    // country of its own (no states) so PR customers find it at the top, and drop
    // it from the US state list (regionOptionsHtml) so there's one way to pick it.
    // Sends country "Puerto Rico", which the Lambda routes to WhatsApp freight.
    if (countryCache.length && !seen.has("Puerto Rico")) {
      const pr = { name: "Puerto Rico", label: "Puerto Rico", provinces: [] };
      const at = countryCache.findIndex((c) => c.name.localeCompare("Puerto Rico") > 0);
      countryCache.splice(at === -1 ? countryCache.length : at, 0, pr);
    }
    return countryCache;
  }

  const findCountry = (name) => getCountries().find((c) => c.name === name) || null;
  const countryHasRegions = (name) => !!(findCountry(name)?.provinces.length);

  // State is required only when the chosen country has a state list. In the
  // free-text fallback (no country data) it stays required, as before.
  const regionRequired = (name) => !getCountries().length || countryHasRegions(name);

  function regionOptionsHtml(countryName) {
    const provinces = (findCountry(countryName)?.provinces || [])
      .filter(([value]) => !(countryName === "United States" && value === "Puerto Rico"));
    return `<option value="">${T("Select…")}</option>` + provinces.map(([value, label]) =>
      `<option value="${escapeHtml(value)}" ${value === state.region ? "selected" : ""}>${escapeHtml(label || value)}</option>`
    ).join("");
  }

  // US + PR say "ZIP code"; everywhere else it's a postal code.
  const zipLabel = (country) => (!country || country === "United States" || country === "Puerto Rico") ? T("ZIP code") : T("Postal code");

  // Country is the first field of step 2 (full width): it decides whether a
  // State/Province field shows and what the postal field is called, so picking
  // it first means nothing below it changes shape after the customer types.
  function countryField() {
    const countries = getCountries();
    if (!countries.length) return `
      <div class="fwq-field" style="grid-column:1/-1">
        <label for="fwq_country">${T("Country")}</label>
        <input id="fwq_country" class="fwq-input" autocomplete="country-name" value="${escapeHtml(state.country)}" placeholder="${T("Country")}" />
      </div>`;
    const pinned = PINNED_COUNTRIES.map(findCountry).filter(Boolean);
    let selectedUsed = false;
    const opt = (c) => {
      const sel = !selectedUsed && c.name === state.country;
      if (sel) selectedUsed = true;
      return `<option value="${escapeHtml(c.name)}" ${sel ? "selected" : ""}>${escapeHtml(c.label)}</option>`;
    };
    return `
      <div class="fwq-field" style="grid-column:1/-1">
        <label for="fwq_country">${T("Country")}</label>
        <select id="fwq_country" class="fwq-input" autocomplete="country-name" required>
          <option value="" ${!state.country ? "selected" : ""}>${T("Select country…")}</option>
          ${pinned.map(opt).join("")}
          ${pinned.length ? `<option disabled>──────────</option>` : ""}
          ${countries.map(opt).join("")}
        </select>
      </div>`;
  }

  // Sits beside City. Hidden for countries without a state list; ZIP is pinned
  // to column 1 (see step2), so hiding State just leaves City alone on its row.
  function regionField() {
    if (!getCountries().length) return `
      <div class="fwq-field">
        <label for="fwq_region">${T("State")}</label>
        <input id="fwq_region" class="fwq-input" autocomplete="address-level1" value="${escapeHtml(state.region)}" placeholder="${T("State")}" />
      </div>`;
    return `
      <div class="fwq-field" id="fwq_region_field" ${countryHasRegions(state.country) ? "" : `style="display:none"`}>
        <label for="fwq_region">${T("State / Province")}</label>
        <select id="fwq_region" class="fwq-input" autocomplete="address-level1">
          ${regionOptionsHtml(state.country)}
        </select>
      </div>`;
  }

  function step2() {
  return `
    <div class="fwq-grid">
      ${countryField()}

      <div class="fwq-field" style="grid-column:1/-1">
        <label for="fwq_street">${T("Street Address")}</label>
        <input
          id="fwq_street"
          class="fwq-input"
          autocomplete="street-address"
          value="${escapeHtml(state.street)}"
          placeholder="${T("Street address")}"
        />
      </div>

      <div class="fwq-field" style="grid-column:1/-1">
        <label for="fwq_street2">${T("Address Line 2 (optional)")}</label>
        <input
          id="fwq_street2"
          class="fwq-input"
          autocomplete="address-line2"
          value="${escapeHtml(state.street2 || "")}"
          placeholder="${T("Apartment, suite, unit, floor, etc.")}"
        />
      </div>

      <div class="fwq-field">
        <label for="fwq_city">${T("City")}</label>
        <input
          id="fwq_city"
          class="fwq-input"
          autocomplete="address-level2"
          value="${escapeHtml(state.city || "")}"
          placeholder="${T("City")}"
          required
        />
      </div>

      ${regionField()}

      <div class="fwq-field" style="grid-column:1">
        <label for="fwq_zip" id="fwq_zip_label">${zipLabel(state.country)}</label>
        <input
          id="fwq_zip"
          class="fwq-input"
          autocomplete="postal-code"
          value="${escapeHtml(state.zip)}"
          placeholder="${zipLabel(state.country)}"
        />
      </div>

      <div class="fwq-field">
        <label for="fwq_address_type">${T("Address Type")}</label>
        <select id="fwq_address_type" class="fwq-input" required>
          <option value="" ${!state.addressType ? "selected" : ""}>${T("Select…")}</option>
          <option value="residential" ${state.addressType === "residential" ? "selected" : ""}>${T("Residential")}</option>
          <option value="commercial" ${state.addressType === "commercial" ? "selected" : ""}>${T("Commercial")}</option>
        </select>
      </div>

    </div>

    <div class="fwq-actions">
      <button class="fwq-btn" id="fwq_back_2">← Previous Step</button>
      <button class="fwq-btn fwq-btn-primary" id="fwq_next_2">${T("Next Step →")}</button>
    </div>
  `;
}


  function step3() {
    const productsHtml = state.products.map(item => `
      <div class="fwq-pill">
        <div class="fwq-pill-left">
          <img class="fwq-mini" src="${escapeHtml(item.productImage || "")}" alt="" onerror="this.style.display='none'" />
          <div>
            <div class="fwq-pill-name">${escapeHtml(item.productTitle)}</div>
            <div class="fwq-itemmeta">
              ${item.variantTitle ? `Variant: ${escapeHtml(item.variantTitle)} • ` : ""}
              Qty: ${Number(item.qty || 1)}
            </div>
          </div>
        </div>
      </div>
    `).join("");

    return `
      <div class="fwq-review">
        <div class="fwq-reviewbox">
          <h3>${T("Customer")}</h3>
          <div class="fwq-kv">
            <div>${T("First Name")}</div><div>${escapeHtml(state.firstName)}</div>
            <div>${T("Last Name")}</div><div>${escapeHtml(state.lastName)}</div>
            <div>${T("Company")}</div><div>${escapeHtml(state.company || "—")}</div>
            <div>${T("Email")}</div><div>${escapeHtml(state.email)}</div>
            <div>${T("Phone")}</div><div>${escapeHtml(state.phone)}</div>
          </div>
        </div>

        <div class="fwq-reviewbox">
          <h3>${T("Shipping Address")}</h3>
          <div class="fwq-kv">
            <div>${T("Street")}</div><div>${escapeHtml(state.street)}</div>
            <div>${T("Address 2")}</div><div>${escapeHtml(state.street2 || "—")}</div>
            <div>${T("City")}</div><div>${escapeHtml(state.city || "—")}</div>
            <div>${T("Country")}</div><div>${escapeHtml(state.country)}</div>
            <div>${T("State")}</div><div>${escapeHtml(state.region || "—")}</div>
            <div>${zipLabel(state.country)}</div><div>${escapeHtml(state.zip)}</div>
          </div>
        </div>

        <div class="fwq-reviewbox" style="grid-column:1/-1">
          <h3>${T("Products")}</h3>
          ${state.products.length ? productsHtml : `<div class="fwq-alert is-error">${T("No products selected.")}</div>`}
        </div>
      </div>

      <div class="fwq-actions">
        <button class="fwq-btn" id="fwq_back_3">← Previous Step</button>
        <button class="fwq-btn fwq-btn-primary" id="fwq_submit" ${state.loading ? "disabled" : ""}>
          ${state.loading ? T("Submitting...") : T("Submit Request")}
        </button>
      </div>
    `;
  }

  // ====== EVENTS ======
  function bindEvents(app) {
    // Step 1 inputs
    const first = $("#fwq_first", app);
    const last = $("#fwq_last", app);
    const company = $("#fwq_company", app);
    const email = $("#fwq_email", app);
    const phone = $("#fwq_phone", app);

    if (first) first.addEventListener("input", (e) => state.firstName = e.target.value.trim());
    if (last) last.addEventListener("input", (e) => state.lastName = e.target.value.trim());
    if (company) company.addEventListener("input", (e) => state.company = e.target.value.trim());
    if (email) email.addEventListener("input", (e) => state.email = e.target.value.trim());
    if (phone) phone.addEventListener("input", (e) => state.phone = normalizePhone(e.target.value));

    // Variant picker controls
const vpCancel = $("#fwq_variant_cancel", app);
if (vpCancel) vpCancel.addEventListener("click", () => {
  state.variantPicker = null;
  render(app);
});

// Option pill clicks (multi-option)
$$(".fwq-swatch-pillbtn", app).forEach(btn => {
  btn.addEventListener("click", () => {
    if (!state.variantPicker) return;

    const opt = btn.getAttribute("data-opt");
    const val = btn.getAttribute("data-val");

    const vp = state.variantPicker;
    vp.selectedOptions = vp.selectedOptions || {};
    vp.selectedOptions[opt] = val;

    // Update selectedId based on current selections
    const optionNames = vp.optionNames || [];
    const variants = vp.variants || [];

    const match = variants.find(v =>
      optionNames.every((name, idx) => (v.values?.[idx] || "") === (vp.selectedOptions[name] || ""))
    );

    vp.selectedId = match?.id || null;
    render(app);
  });
});


    const vpAdd = $("#fwq_variant_add", app);
if (vpAdd) vpAdd.addEventListener("click", () => {
  if (!state.variantPicker) return;

  const vp = state.variantPicker;
  const optionNames = vp.optionNames || [];
  const variants = vp.variants || [];

  const match = variants.find(v =>
    optionNames.every((name, idx) => (v.values?.[idx] || "") === (vp.selectedOptions?.[name] || ""))
  );

  if (match && match.available !== false) {
    addLineItemFromVariant(vp.product, match);
  }

  state.variantPicker = null;
  render(app);
});


    // Product search
    const search = $("#fwq_product_search", app);
    const results = $("#fwq_results", app);

    if (search && results) {
      const doSearch = debounce(async () => {
        const q = search.value.trim();
        if (q.length < 2) {
          results.style.display = "none";
          results.innerHTML = "";
          return;
        }

        const items = await fetchProducts(q);
        if (!items.length) {
          results.innerHTML = `<div class="fwq-item"><div>${T("No results")}</div></div>`;
          results.style.display = "block";
          return;
        }

        results.innerHTML = items.map(p => `
          <div class="fwq-item" data-add="${escapeHtml(p.id)}"
               data-title="${escapeHtml(p.title)}"
               data-url="${escapeHtml(p.url)}"
               data-image="${escapeHtml(p.image || "")}"
               data-handle="${escapeHtml(p.handle || "")}">
            <img class="fwq-thumb" src="${escapeHtml(p.image || "")}" alt="" onerror="this.style.display='none'" />
            <div>
              <div class="fwq-itemtitle">${escapeHtml(p.title)}</div>
              <div class="fwq-itemmeta">${escapeHtml(p.vendor || "")}</div>
            </div>
          </div>
        `).join("");

        results.style.display = "block";
      }, 250);

      search.addEventListener("input", () => {
        // If user starts typing again, close variant picker
        if (state.variantPicker) state.variantPicker = null;
        doSearch();
      });


      // click result -> if variants, show checklist; else add immediately
      results.addEventListener("click", async (e) => {
        const row = e.target.closest(".fwq-item[data-add]");
        if (!row) return;

        const product = {
          id: row.getAttribute("data-add"),
          title: row.getAttribute("data-title"),
          url: row.getAttribute("data-url"),
          image: row.getAttribute("data-image"),
          handle: row.getAttribute("data-handle") || getHandleFromUrl(row.getAttribute("data-url") || ""),
        };

        results.style.display = "none";
        search.value = "";

        await addProductToQuote(product, app);
      });
    }

    // Selected products: qty + remove
    $$(".fwq-pill", app).forEach(pill => {
      const key = pill.getAttribute("data-key");
      const qtyInput = $(".fwq-qty-input", pill);
      const removeBtn = $(".fwq-remove", pill);

      if (qtyInput) {
        qtyInput.addEventListener("input", () => {
          const v = Math.max(1, parseInt(qtyInput.value || "1", 10));
          const item = state.products.find(x => String(x.key) === String(key));
          if (item) item.qty = v;
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener("click", () => {
          const removed = state.products.find(x => String(x.key) === String(key));
          state.products = state.products.filter(x => String(x.key) !== String(key));
          // Removing a companion line (e.g. the gas burner) updates the oven line's choice text,
          // unless another line of that product is still on the quote.
          if (removed && removed.productHandle && !state.products.some(x => x.productHandle === removed.productHandle)) {
            applyCompanionSwaps(removed.productHandle, false);
          }
          render(app);
        });
      }
    });

    // Navigation
    const next1 = $("#fwq_next_1", app);
    if (next1) next1.addEventListener("click", () => {
      state.message = null;
      const err = validateStep1();
      if (err) return setError(err, app);
      state.step = 2;
      render(app);
    });

    const back2 = $("#fwq_back_2", app);
    if (back2) back2.addEventListener("click", () => { state.message = null; state.step = 1; render(app); });

    // Country dropdown → rebuild the State/Province list in place (no full
    // re-render, so the street/city/zip already typed are kept).
    const countrySel = $("#fwq_country", app);
    if (countrySel && countrySel.tagName === "SELECT") countrySel.addEventListener("change", () => {
      state.country = countrySel.value;
      state.region = "";
      const regionSel = $("#fwq_region", app);
      const regionField = $("#fwq_region_field", app);
      if (regionSel) regionSel.innerHTML = regionOptionsHtml(state.country);
      if (regionField) regionField.style.display = countryHasRegions(state.country) ? "" : "none";
      const zipLbl = $("#fwq_zip_label", app);
      const zipInput = $("#fwq_zip", app);
      if (zipLbl) zipLbl.textContent = zipLabel(state.country);
      if (zipInput) zipInput.placeholder = zipLabel(state.country);
    });

    const next2 = $("#fwq_next_2", app);
    if (next2) next2.addEventListener("click", () => {
      state.message = null;

      // collect step2 values
      state.street  = ($("#fwq_street", app)?.value || "").trim();
      state.street2 = ($("#fwq_street2", app)?.value || "").trim();
      state.city    = ($("#fwq_city", app)?.value || "").trim();
      state.country = ($("#fwq_country", app)?.value || "").trim();
      state.region  = ($("#fwq_region", app)?.value || "").trim();
      state.zip     = ($("#fwq_zip", app)?.value || "").trim();
      state.addressType = ($("#fwq_address_type", app)?.value || "").trim();

      const err = validateStep2();
      if (err) return setError(err, app);
      state.step = 3;
      render(app);
    });

    const back3 = $("#fwq_back_3", app);
    if (back3) back3.addEventListener("click", () => { state.message = null; state.step = 2; render(app); });

    const submit = $("#fwq_submit", app);
    if (submit) submit.addEventListener("click", async () => {
      state.message = null;
      const err = validateAll();
      if (err) return setError(err, app);

      state.loading = true;
      render(app);

      try {
        const payload = buildPayload();
        const res = await fetch(QUOTE_API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        const text = await res.text();
        let data;
        try { data = JSON.parse(text); } catch { data = { raw: text }; }

        if (!res.ok || data?.ok === false) {
          throw new Error(data?.message || `Request failed (${res.status}).`);
        }

        state.loading = false;
        state.message = { type: "success", text: T("Quote request sent! We’ll review it and email you your quote. If we need any more information, we may reach out by email or phone.") };

        // clear
        state.step = 1;
        state.firstName = "";
        state.lastName = "";
        state.company = "";
        state.email = "";
        state.phone = "";
        state.products = [];
        state.street = "";
        state.street2 = "";
        state.city = "";
        state.country = "";
        state.region = "";
        state.zip = "";
        state.variantPicker = null;

        render(app);
      } catch (e) {
        state.loading = false;
        state.message = { type: "error", text: `${T("Something went wrong. Please call ")}${SUPPORT_PHONE}.` };
        console.error("Quote submit error:", e);
        render(app);
      }
    });
  }

  function setError(msg, app) {
    state.message = { type: "error", text: msg };
    render(app);
  }

  // Color (and other made-to-order choices) the customer picked on the product
  // page arrive as URL params. The oven line is rebuilt here from the variant
  // picker, which only knows the real variant options (e.g. Door Style), so we
  // stamp the captured color onto the matching oven line so it shows in the
  // quote instead of being buried in the page URL. Set by prefillFromUrl.
  let fwqOvenColor = null; // { handle, color }
  let fwqOvenEngraving = null; // { handle, text }
  let fwqOvenBuild = null; // { handle, text } — MAM "Build your oven" spec from the product page
  let fwqOvenOptions = null; // { handle, text } — other product-page choices, e.g. "Fuel Type: Gas/Wood Hybrid (V1-M)"
  // [{ h, on, off }] — when the companion line with handle h is removed, the oven line's
  // "on" text (e.g. "Fuel Type: Gas/Wood Hybrid (V1-M)") becomes "off" ("Fuel Type: Wood-fired").
  let fwqCompanionSwaps = [];
  let fwqCompanionOven = null; // handle of the product those swaps belong to

  function addLineItemFromVariant(product, variant) {
  const variantId = variant ? String(variant.id) : "";

  // If there's no real options, keep blank
  const optionNames = variant?.optionNames || [];
  const values = variant?.values || [];
  const hasRealOptions =
  values.length &&
  !(values.length === 1 && ["Default", "Default Title"].includes(values[0]));

  let variantLabel = "";
  if (hasRealOptions) {
    variantLabel = optionNames
      .map((name, idx) => {
        const val = values[idx] || "";
        if (!name || !val) return "";
        return `${name}: ${val}`;
      })
      .filter(Boolean)
      .join(" / ");
  }

  // Stamp the captured color onto the oven line (matched by handle) so the
  // quote shows it. The burner / other products don't match, so they're clean.
  if (fwqOvenColor && fwqOvenColor.color && product && String(product.handle) === String(fwqOvenColor.handle)) {
    variantLabel = variantLabel ? variantLabel + " · Color: " + fwqOvenColor.color : "Color: " + fwqOvenColor.color;
  }
  if (fwqOvenOptions && fwqOvenOptions.text && product && String(product.handle) === String(fwqOvenOptions.handle)) {
    variantLabel = variantLabel ? variantLabel + " · " + fwqOvenOptions.text : fwqOvenOptions.text;
  }
  if (fwqOvenEngraving && fwqOvenEngraving.text && product && String(product.handle) === String(fwqOvenEngraving.handle)) {
    variantLabel = variantLabel ? variantLabel + " · Engraving: " + fwqOvenEngraving.text : "Engraving: " + fwqOvenEngraving.text;
  }
  if (fwqOvenBuild && fwqOvenBuild.text && product && String(product.handle) === String(fwqOvenBuild.handle)) {
    // The MAM build already names the variant ("Availability: In stock | Oven: …"),
    // so it replaces the option label instead of repeating it.
    variantLabel = fwqOvenBuild.text;
  }

  const sku = variant?.sku || "";
  const isBuild = !!(fwqOvenBuild && fwqOvenBuild.text && product && String(product.handle) === String(fwqOvenBuild.handle));
  const key = `${String(product.id)}::${variantId || "novar"}` + (isBuild ? `::${variantLabel}` : "");

  const existing = state.products.find(x => x.key === key);
  if (existing) {
    existing.qty = Math.min(999, Number(existing.qty || 1) + 1);
    return;
  }

  state.products.push({
    key,
    productId: String(product.id),
    productTitle: product.title,
    productHandle: product.handle || "",
    productUrl: product.url,
    productImage: (variant && variant.image) || product.image, // the chosen variant's photo when it has one
    variantId,
    variantTitle: stripTc(variantLabel), // ✅ e.g. "Size: 32\" / Fuel: NG"
    sku,
    qty: 1,
  });
  applyCompanionSwaps(product && product.handle, true);
}

// Keep the oven line's choice text in step with its companion line (fwqCompanionSwaps):
// added → "on" text ("Fuel Type: Gas/Wood Hybrid (V1-M)"), removed → "off" ("Fuel Type: Wood-fired").
function applyCompanionSwaps(handle, added) {
  if (!handle || !fwqCompanionOven) return;
  fwqCompanionSwaps.filter(sw => sw && sw.h === handle && sw.on).forEach(sw => {
    state.products.forEach(line => {
      if (line.productHandle !== fwqCompanionOven) return;
      const t = line.variantTitle || "";
      if (added) {
        if (t.includes(sw.on)) return;
        line.variantTitle = sw.off && t.includes(sw.off) ? t.replace(sw.off, sw.on) : (t ? t + " · " + sw.on : sw.on);
      } else {
        line.variantTitle = sw.off ? t.replace(sw.on, sw.off) : t.replace(" · " + sw.on, "").replace(sw.on, "");
      }
    });
  });
}


  // Add companion lines (e.g. gas burner) passed from the product page via the
  // companion_handles / companion_variant_ids URL params. Each companion is
  // fetched like any other product and added as its OWN quote line, so a
  // hybrid oven quote reads oven + gas burner. Best-effort: failures are
  // logged and skipped so a bad companion never blocks the oven prefill.
  async function addCompanionLinesFromParams(params) {
    const handles = (params.get("companion_handles") || "").split(",").map(s => s.trim()).filter(Boolean);
    const ids = (params.get("companion_variant_ids") || "").split(",").map(s => s.trim()).filter(Boolean);
    for (let i = 0; i < handles.length; i++) {
      try {
        const res = await fetch(`${ROOT}/products/${encodeURIComponent(handles[i])}.js`, { method: "GET" });
        if (!res.ok) continue;
        const prod = await res.json();
        const prodObj = {
          id: String(prod.id || handles[i]),
          title: prod.title || "",
          url: prod.url || `/products/${handles[i]}`,
          image: (prod.featured_image || prod.images?.[0] || ""),
          handle: prod.handle || handles[i],
        };
        const optionNames = Array.isArray(prod?.options) ? prod.options.map(o => (o?.name || o)).filter(Boolean) : [];
        const variants = Array.isArray(prod?.variants) ? prod.variants : [];
        const wantId = ids[i];
        const v = (wantId && variants.find(x => String(x.id) === String(wantId))) || variants[0] || null;
        let normVar = null;
        if (v) {
          const values = [];
          if (v.option1 && v.option1 !== "Default Title") values.push(v.option1);
          if (v.option2 && v.option2 !== "Default Title") values.push(v.option2);
          if (v.option3 && v.option3 !== "Default Title") values.push(v.option3);
          normVar = { id: v.id, sku: v.sku || "", title: v.title || "", optionNames, values };
        }
        addLineItemFromVariant(prodObj, normVar);
      } catch (e) {
        console.warn("Quote prefill: companion add failed", handles[i], e);
      }
    }
  }

  async function fetchProducts(q) {
  try {
    const url = new URL(SUGGEST_URL, window.location.origin);
    url.searchParams.set("q", q);
    url.searchParams.set("resources[type]", "product");
    url.searchParams.set("resources[limit]", "8");
    // "last", not "hide": made-to-order products are tracked at 0 (so the storefront
    // "In stock only" filter is honest) but must still be quotable.
    url.searchParams.set("resources[options][unavailable_products]", "last");

    // IMPORTANT: don't set resources[options][fields]
    // Some shops stop returning url/handle/image when fields is present.
    const res = await fetch(url.toString(), { method: "GET" });
    if (!res.ok) return [];

    const json = await res.json();
    const products = json?.resources?.results?.products || [];

    // Don't require url; we can build handle from URL when available
    return products
      .map(normalizeProduct)
      .filter(p => p.title); // keep it simple
  } catch (e) {
    console.error("Product search error:", e);
    return [];
  }
}


  // Pop-up motion: a quick fade + scale in/out (skipped with reduced motion). The card
  // pop-up (fwo-quote-modal.js) replaces the "in" with a grow-from-the-button effect.
  const fwqReduceMotion = () => !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  function fwqPopIn(overlay) {
    if (fwqReduceMotion() || !overlay.animate) return;
    overlay.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: "ease-out" });
    const m = overlay.querySelector(".fwq-mam-modal");
    if (m) m.animate([{ transform: "scale(.94)", opacity: 0 }, { transform: "scale(1)", opacity: 1 }], { duration: 240, easing: "cubic-bezier(.16,1,.3,1)" });
  }
  function fwqDismiss(overlay) {
    if (fwqReduceMotion() || !overlay.animate) { overlay.remove(); return; }
    overlay.style.pointerEvents = "none";
    const m = overlay.querySelector(".fwq-mam-modal");
    if (m) m.animate([{ transform: "scale(1)", opacity: 1 }, { transform: "scale(.94)", opacity: 0 }], { duration: 180, easing: "ease-in", fill: "forwards" });
    overlay.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: "ease-in", fill: "forwards" })
      .finished.then(() => overlay.remove(), () => overlay.remove());
  }

  // ====== MAM BUILDER POP-UP ======
  // Data: /products/<handle>?view=mambuilder (templates/product.mambuilder.liquid);
  // engine: window.FwoMamBuilder (assets/fwo-mam-builder.js, loaded by
  // layout/theme.liquid on this page). Returns false (→ normal variant picker)
  // for products without a builder or if the engine isn't loaded.
  async function fetchMamBuilderData(handle) {
    // null when not JSON (e.g. the view template is missing) → not a builder product
    const data = await fetchJsonText(productViewUrl(handle, "mambuilder"));
    return data && data.config && Array.isArray(data.config.axes) ? data : null;
  }

  function ensureMamModalStyles() {
    if (document.getElementById("fwq-mam-modal-css")) return;
    const st = document.createElement("style");
    st.id = "fwq-mam-modal-css";
    st.textContent = [
      ".fwq-mam-overlay{position:fixed;inset:0;z-index:10000;background:rgba(20,16,12,.55);display:flex;align-items:center;justify-content:center;padding:16px}",
      ".fwq-mam-modal{position:relative;background:#fff;border-radius:16px;width:100%;max-width:720px;max-height:calc(100vh - 32px);display:flex;flex-direction:column;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.25)}",
      ".fwq-mam-scroll{overflow-y:auto;padding:20px 22px 8px}",
      ".fwq-mam-media{display:flex;justify-content:center;background:#fafafa;border-radius:12px;margin:0 0 16px}",
      ".fwq-mam-media img{max-height:240px;max-width:100%;object-fit:contain;display:block}",
      ".fwq-mam-close{position:absolute;top:10px;right:12px;width:36px;height:36px;border:0;border-radius:50%;background:#fff;font-size:22px;line-height:1;cursor:pointer;z-index:1}",
      ".fwq-mam-actions{display:flex;justify-content:space-between;gap:12px;padding:14px 22px;border-top:1px solid #eee;background:#fff}",
      "@media(max-width:600px){.fwq-mam-overlay{padding:0}.fwq-mam-modal{max-height:100vh;height:100%;border-radius:0}.fwq-mam-media img{max-height:180px}}"
    ].join("\n");
    document.head.appendChild(st);
  }

  async function openMamBuilder(product, variants, app) {
    if (!window.FwoMamBuilder) return false;
    const data = await fetchMamBuilderData(product.handle);
    if (!data) return false;
    ensureMamModalStyles();

    const name = String(data.title || product.title || "").split(" — ")[0];
    const firstSrc = (data.media && data.media[0] && data.media[0].src) || product.image || "";
    const overlay = document.createElement("div");
    overlay.className = "fwq-mam-overlay";
    overlay.innerHTML = `
      <div class="fwq-mam-modal" role="dialog" aria-modal="true" aria-label="${T("Build your ")}${escapeHtml(name)}">
        <button type="button" class="fwq-mam-close" aria-label="Close">&times;</button>
        <div class="fwq-mam-scroll">
          <div class="fwq-mam-media">${firstSrc ? `<img alt="" src="${escapeHtml(firstSrc)}">` : ""}</div>
          <div class="fwo-mam js-fwq-mam-body">
            <p class="fwo-mam__head">${T("Build your ")}${escapeHtml(name)}</p>
            <p class="fwo-mam__sub">${T(data.units && data.units.length ? "Choose each option, or pick an oven we have in stock — the photo updates to the closest real oven." : "Choose each option — the photo updates to the closest real oven.")}</p>
            ${window.FwoMamBuilder.shellHtml()}
          </div>
        </div>
        <div class="fwq-mam-actions">
          <button type="button" class="fwq-btn js-fwq-mam-cancel">${T("Cancel")}</button>
          <button type="button" class="fwq-btn fwq-btn-primary js-fwq-mam-add">${T("Add to Quote")}</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    fwqPopIn(overlay);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const img = overlay.querySelector(".fwq-mam-media img");
    const api = window.FwoMamBuilder.create(overlay.querySelector(".js-fwq-mam-body"), data, {
      showMedia: (m) => { if (img && m && m.src) { img.src = m.src; } }
    });

    function onKey(e) { if (e.key === "Escape") close(); }
    function close() {
      fwqDismiss(overlay);
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKey);
    }
    document.addEventListener("keydown", onKey);
    overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
    overlay.querySelector(".fwq-mam-close").addEventListener("click", close);
    overlay.querySelector(".js-fwq-mam-cancel").addEventListener("click", close);
    overlay.querySelector(".js-fwq-mam-add").addEventListener("click", () => {
      const missing = api.missing();
      if (missing.length) { api.showMissing(missing); return; }
      const vid = String(api.variantId() || "");
      const variant = variants.find(v => String(v.id) === vid) || null;
      const prevBuild = fwqOvenBuild;
      fwqOvenBuild = { handle: product.handle, text: api.spec().slice(0, 900) };
      addLineItemFromVariant(product, variant);
      fwqOvenBuild = prevBuild;
      close();
      render(app);
    });
    return true;
  }

  // ====== OVEN OPTIONS POP-UP ======
  // Same questions the product page asks (variant options, Color, Fuel Type,
  // gas burner / base companions, Engraving), for quotes started from a product
  // card or the search box. Data: /products/<handle>?view=quoteoptions
  // (templates/product.quoteoptions.liquid → snippets/fwo-quote-options-data.liquid);
  // logic + pills: FwoMamBuilder.ovenOptions (assets/fwo-mam-builder.js), the same
  // engine as the product-page picker. Returns false (→ normal flow) when the
  // product has nothing to configure or the data / engine isn't available.
  async function fetchQuoteOptions(handle) {
    const data = await fetchJsonText(productViewUrl(handle, "quoteoptions"));
    return data && Array.isArray(data.variants) ? data : null;
  }

  async function openQuoteOptions(product, variants, app, preferVariantId) {
    const oo = window.FwoMamBuilder && window.FwoMamBuilder.ovenOptions;
    if (!oo) return false;
    const data = await fetchQuoteOptions(product.handle);
    if (!data || !oo.needed(data)) return false;
    ensureMamModalStyles();

    const title = escapeHtml(data.title || product.title);
    const overlay = document.createElement("div");
    overlay.className = "fwq-mam-overlay";
    overlay.innerHTML = `
      <div class="fwq-mam-modal" role="dialog" aria-modal="true" aria-label="${T("Customize your ")}${title}">
        <button type="button" class="fwq-mam-close" aria-label="Close">&times;</button>
        <div class="fwq-mam-scroll">
          <div class="fwq-mam-media"><img alt="" src="${escapeHtml(data.image || product.image || "")}"></div>
          <div class="fwo-mam">
            <p class="fwo-mam__head">${T("Customize your ")}${title}</p>
            <p class="fwo-mam__sub">${T("Choose your options so we can quote exactly what you need.")}</p>
            <div class="js-fwq-qo-body"></div>
          </div>
        </div>
        <div class="fwq-mam-actions">
          <button type="button" class="fwq-btn js-fwq-qo-cancel">${T("Cancel")}</button>
          <button type="button" class="fwq-btn fwq-btn-primary js-fwq-qo-add">${T("Add to Quote")}</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    fwqPopIn(overlay);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const imgEl = overlay.querySelector(".fwq-mam-media img");
    // Engine: FwoMamBuilder.ovenOptions (assets/fwo-mam-builder.js) — shared with the product page.
    const api = oo.create(overlay.querySelector(".js-fwq-qo-body"), data, {
      variantId: preferVariantId,
      showImage: (img) => { if (img && img.src) imgEl.src = img.src; },
    });

    function onKey(e) { if (e.key === "Escape") close(); }
    function close() {
      fwqDismiss(overlay);
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKey);
    }
    document.addEventListener("keydown", onKey);
    overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
    overlay.querySelector(".fwq-mam-close").addEventListener("click", close);
    overlay.querySelector(".js-fwq-qo-cancel").addEventListener("click", close);
    overlay.querySelector(".js-fwq-qo-add").addEventListener("click", async () => {
      const m = api.missing();
      if (m.length) { api.showMissing(m, false); return; }
      const v = api.variant() || data.variants[0];
      const variant = variants.find(x => String(x.id) === String(v.id)) || null;

      // One label carrying every choice; it also keys the line, so the same oven
      // in two colors becomes two quote lines.
      const prevBuild = fwqOvenBuild;
      fwqOvenBuild = { handle: product.handle, text: api.spec() };
      addLineItemFromVariant(product, variant);
      fwqOvenBuild = prevBuild;

      // Burner / base go on their own lines, like a quote from the product page.
      const comps = api.companions();
      close();
      if (comps.length) {
        await addCompanionLinesFromParams(new URLSearchParams({
          companion_handles: comps.map(c => c.handle).join(","),
          companion_variant_ids: comps.map(c => String(c.id)).join(","),
        }));
      }
      render(app);
    });
    return true;
  }

  // ====== YOU MIGHT ALSO LIKE ======
  // Category rules: a quoted product in any `from` collection recommends products
  // from the `to` collections (first two that have something new to show, 4 each).
  // Collection membership: /products/<handle>?view=quotecollections
  // (templates/product.quotecollections.liquid). Edit the rules here.
  const FWQ_REC_RULES = [
    { from: ["pizza-hub-ovens", "hornos-profesionales", "mam-forni", "alfa-pro", "fwo-pro", "edge-conveyer-ovens"],
      to: [{ handle: "pizza-hub-pizza-tools", title: "Pizza Tools" }, { handle: "pizza-hub-dough-storage-management", title: "Dough Storage & Management" }] },
    { from: ["hornos-domesticos", "modern-ovens", "alfa-home-ovens"],
      to: [{ handle: "pizza-accessories", title: "Pizza Accessories" }, { handle: "firewood", title: "Firewood" }] },
    { from: ["pizza-hub-mixers", "spiral-dough-mixers"],
      to: [{ handle: "pizza-hub-dough-storage-management", title: "Dough Storage & Management" }, { handle: "dough-rounders-dividers", title: "Dough Rounders & Dividers" }] },
    { from: ["dough-rounders-dividers", "dough-formers", "pizzarella"],
      to: [{ handle: "pizza-hub-dough-storage-management", title: "Dough Storage & Management" }, { handle: "pizza-hub-pizza-tools", title: "Pizza Tools" }] },
    { from: ["pizza-hub-pizza-prep-tables"],
      to: [{ handle: "pizza-hub-pizza-tools", title: "Pizza Tools" }] },
    { from: ["bbq-grills", "parrilla-argentina", "bbq-grill-kits", "diy-bbq-kits"],
      to: [{ handle: "bbq-smoking-wood", title: "BBQ Smoking Wood" }, { handle: "fire-starters", title: "Fire Starters" }] },
  ];
  const FWQ_RECS_PER_GROUP = 4;
  const fwqCollectionsOf = new Map();   // product handle -> Promise<[collection handles]>
  const fwqCollectionProducts = new Map(); // collection handle -> Promise<[products]>
  const fwqRecsHtml = new Map();        // quote signature -> html

  const quoteHandles = (products) => {
    const out = [];
    products.slice().reverse().forEach(p => { // most recently added first
      const h = getHandleFromUrl(p.productUrl || "");
      if (h && !out.includes(h)) out.push(h);
    });
    return out;
  };
  const recsSignature = (products) => quoteHandles(products).join(",");

  function fetchJsonCached(map, key, url) {
    if (!map.has(key)) {
      map.set(key, fetch(url).then(r => (r.ok ? r.json() : null)).catch(() => null));
    }
    return map.get(key);
  }

  async function buildRecsHtml(products) {
    const inQuote = quoteHandles(products);
    const targets = [];
    for (const h of inQuote) {
      const cols = (await fetchJsonCached(fwqCollectionsOf, h, `${ROOT}/products/${encodeURIComponent(h)}?view=quotecollections`)) || [];
      FWQ_REC_RULES.forEach(rule => {
        if (!rule.from.some(c => cols.includes(c))) return;
        rule.to.forEach(t => { if (!targets.some(x => x.handle === t.handle)) targets.push(t); });
      });
    }
    const groups = [];
    for (const t of targets) {
      if (groups.length >= 2) break;
      const json = await fetchJsonCached(fwqCollectionProducts, t.handle, `/collections/${encodeURIComponent(t.handle)}/products.json?limit=30`);
      const picks = ((json && json.products) || [])
        .filter(p => !inQuote.includes(p.handle) && (p.variants || []).some(v => v.available))
        .slice(0, FWQ_RECS_PER_GROUP);
      if (picks.length) groups.push({ t, picks });
    }
    if (!groups.length) return "";
    return `
      <div class="fwq-recs">
        <div class="fwq-recs-title">${T("You might also like…")}</div>
        ${groups.map(({ t, picks }) => `
          <div class="fwq-recs-group">
            <div class="fwq-recs-head">
              <span>${escapeHtml(t.title)}</span>
              <a href="/collections/${escapeHtml(t.handle)}" target="_blank" rel="noopener" aria-label="See all ${escapeHtml(t.title)}">${T("See all →")}</a>
            </div>
            <div class="fwq-recs-grid">
              ${picks.map(p => {
                const img = p.images && p.images[0] ? p.images[0].src : "";
                return `
                <div class="fwq-rec">
                  <a class="fwq-rec-media" href="/products/${escapeHtml(p.handle)}" target="_blank" rel="noopener">
                    ${img ? `<img src="${escapeHtml(img)}${img.includes("?") ? "&" : "?"}width=300" alt="" loading="lazy">` : ""}
                  </a>
                  <div class="fwq-rec-title">${escapeHtml(p.title)}</div>
                  <button type="button" class="fwq-btn fwq-rec-add"
                    data-rec-id="${escapeHtml(String(p.id))}" data-rec-handle="${escapeHtml(p.handle)}"
                    data-rec-title="${escapeHtml(p.title)}" data-rec-image="${escapeHtml(img)}">${T("Add to quote")}</button>
                </div>`;
              }).join("")}
            </div>
          </div>`).join("")}
      </div>`;
  }

  // Synchronous part of render(): cached html for this quote, or "" while it loads.
  function recsHtmlFor(products) {
    return fwqRecsHtml.get(recsSignature(products)) || "";
  }

  // After each render: compute recommendations for the current quote and drop them in.
  async function refreshRecs(app) {
    const el = $("#fwq_recs", app);
    if (!el || state.step !== 1) return;
    const sig = recsSignature(state.products);
    if (!sig) { el.innerHTML = ""; return; }
    if (fwqRecsHtml.has(sig)) return; // already rendered by recsHtmlFor
    let html = "";
    try { html = await buildRecsHtml(state.products); } catch (e) { console.warn("Quote recs failed", e); }
    fwqRecsHtml.set(sig, html);
    const live = $("#fwq_recs", app);
    if (live && recsSignature(state.products) === sig) live.innerHTML = html;
  }

  // Add to quote handler (delegated once per app element, since render() replaces the markup).
  function bindRecs(app) {
    if (app.__fwqRecsBound) return;
    app.__fwqRecsBound = true;
    app.addEventListener("click", async (e) => {
      const btn = e.target.closest(".fwq-rec-add");
      if (!btn || !app.contains(btn)) return;
      btn.disabled = true;
      const handle = btn.getAttribute("data-rec-handle");
      await addProductToQuote({
        id: btn.getAttribute("data-rec-id"),
        title: btn.getAttribute("data-rec-title"),
        url: `/products/${handle}`,
        image: btn.getAttribute("data-rec-image"),
        handle,
      }, app);
      btn.disabled = false;
      // Products with plain variants open the picker under the search box — bring it into view.
      if (state.variantPicker) {
        const search = $("#fwq_product_search", app);
        if (search) search.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }

  // Add a product to the quote the same way everywhere (search result, "You might
  // also like"): MAM builder → oven options pop-up → plain add / variant picker.
  async function addProductToQuote(product, app) {
    // Fetch variants
        const variants = await fetchProductVariants(product.handle);

        // MAM builder products: the build happens in a pop-up (same engine as the
        // product page), so a quote can't go out for a MAM oven without a build.
        if (await openMamBuilder(product, variants, app)) return;
        // Configurable ovens (Color, Fuel Type, burner, engraving…): same questions as the product page.
        if (await openQuoteOptions(product, variants, app)) return;

        // If no variants or single "Default Title", just add as a normal item
        if (!variants.length) {
          addLineItemFromVariant(product, null);
          render(app);
          return;
        }

        // If multiple real variants, show checklist under the search bar
        const firstVals = variants[0]?.values || [];
const firstHasReal = firstVals.some(v => v && !["Default", "Default Title"].includes(v));
const hasRealChoices = variants.length > 1 || firstHasReal;
        if (!hasRealChoices) {
          addLineItemFromVariant(product, variants[0]);
          render(app);
          return;
        }

     const optionNames = variants[0]?.optionNames || [];
const firstAvail = variants.find(v => v.available !== false) || variants[0];

// Build default selections from first available variant (so UI has a default)
const selectedOptions = {};
(optionNames || []).forEach((name, idx) => {
  selectedOptions[name] = firstAvail?.values?.[idx] || "";
});

state.variantPicker = {
  product,
  variants,
  optionNames,
  selectedOptions, // { "Interior Diameter": '32"', "Fuel": "NG" }
  selectedId: firstAvail?.id || null
};

        render(app);
  }

async function fetchProductVariants(handle) {
  try {
    if (!handle) return [];
    prefetchProduct(handle); // builder + options data load alongside
    const product = await fetchProductJs(handle);
    if (!product) return [];

    // Option names: ["Size","Color"] etc.
    const optionNames =
      (Array.isArray(product?.options) ? product.options.map(o => (o?.name || o)).filter(Boolean) : []) ||
      [];

    const variants = Array.isArray(product?.variants) ? product.variants : [];

    return variants.map(v => {
      const values = [];
      if (v.option1 && v.option1 !== "Default Title") values.push(v.option1);
      if (v.option2 && v.option2 !== "Default Title") values.push(v.option2);
      if (v.option3 && v.option3 !== "Default Title") values.push(v.option3);

      return {
        id: v.id,
        available: v.available,
        sku: v.sku || "",
        title: v.title || "",
        optionNames,
        values, // e.g. ["32\"", "Natural Gas"]
      };
    });
  } catch (e) {
    console.error("Variant fetch error:", e);
    return [];
  }
}



  // ====== VALIDATION / PAYLOAD ======
  function validateStep1() {
    if (!state.firstName) return T("Please enter your First Name.");
    if (!state.lastName) return T("Please enter your Last Name.");
    if (!state.email || !isEmail(state.email)) return T("Please enter a valid Email address.");
    if (!state.phone) return T("Please enter your Phone number.");
    if (!state.products.length) return T("Please select at least one product (and variant if applicable).");
    return null;
  }

  function validateStep2() {
    if (!state.street) return T("Please enter your Street Address.");
    if (!state.city) return T("Please enter your City.");
    if (!state.country) return T("Please select your Country.");
    if (!state.region && regionRequired(state.country)) return T("Please select your State.");
    if (!state.zip) return `${T("Please enter your ")}${zipLabel(state.country)}.`;
    if (!state.addressType) return T("Please select if this is a Residential or Commercial address.");
    return null;
}


  function validateAll() {
    return validateStep1() || validateStep2();
  }

  function buildPayload() {
    return {
      source: "shopify",
      page: window.location.href,
      // the Hub tags Spanish-site requests so the PDF quote + email default to Spanish
      lang: String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || "en").slice(0, 2).toLowerCase() === "es" ? "es" : "en",
      submittedAt: new Date().toISOString(),
      customer: {
        firstName: state.firstName,
        lastName: state.lastName,
        company: state.company || "",
        email: state.email,
        phone: state.phone,
      },
      shippingAddress: {
        street: state.street,
        street2: state.street2 || "",
        city: state.city,
        country: state.country,
        state: state.region,
        zip: state.zip,
        addressType: state.addressType
      },

      products: state.products.map(item => ({
        productId: item.productId,
        productTitle: item.productTitle,
        productUrl: item.productUrl,
        productImage: item.productImage,
        variantId: item.variantId || "",
        variantTitle: item.variantTitle || "",
        sku: item.sku || "",
        qty: Number(item.qty || 1)
      }))
    };
  }

  // ====== PREFILL FROM URL PARAMS ======
  // When the customer arrives from a product page via the "Request a Quote"
  // button, the URL contains query params describing the product they were
  // viewing. We use those to pre-open the variant picker (if applicable) so
  // the customer doesn't have to search for the product again.
  //
  // Expected URL params (all optional, all best-effort):
  //   product_handle   — required; we use this to fetch product data
  //   variant_id       — optional; if present, pre-selects that variant
  //   product_title    — optional; used for fallback display only
  //   product_url      — optional; used for fallback display only
  //
  // Failure mode: any error here is silently swallowed. The customer ends up
  // looking at the empty form and can search manually. We log warnings to
  // console for debugging.
  async function prefillFromUrl(app, search) {
    try {
      const params = new URLSearchParams(search == null ? window.location.search : search);
      const productHandle = params.get("product_handle");
      const variantIdParam = params.get("variant_id");
      const productTitleParam = params.get("product_title") || "";
      const productUrlParam = params.get("product_url") || "";

      if (!productHandle) return; // nothing to prefill

      // Fetch product data (+ builder / options data in parallel; usually already
      // prefetched on card hover).
      prefetchProduct(productHandle);
      const product = await fetchProductJs(productHandle);
      if (!product) {
        console.warn("Quote prefill: product fetch failed", productHandle);
        return;
      }

      // Build the product object in the shape the rest of the code expects
      const productObj = {
        id: String(product.id || productHandle),
        title: product.title || productTitleParam,
        url: product.url || productUrlParam,
        image: (product.featured_image || product.images?.[0] || ""),
        handle: product.handle || productHandle,
      };

      // Capture the chosen color (from the product page) so it gets stamped
      // onto the oven line when it's added, regardless of which door variant
      // the customer confirms in the picker.
      const colorParam = params.get("color");
      if (colorParam) fwqOvenColor = { handle: productObj.handle, color: colorParam };
      const engravingParam = params.get("engraving");
      if (engravingParam) fwqOvenEngraving = { handle: productObj.handle, text: engravingParam };
      const buildParam = params.get("build");
      if (buildParam) fwqOvenBuild = { handle: productObj.handle, text: buildParam.slice(0, 900) };
      const optionsParam = params.get("options");
      if (optionsParam) fwqOvenOptions = { handle: productObj.handle, text: optionsParam.slice(0, 400) };
      try {
        const sw = JSON.parse(params.get("companion_swaps") || "[]");
        if (Array.isArray(sw) && sw.length) { fwqCompanionSwaps = sw; fwqCompanionOven = productObj.handle; }
      } catch (e) {}

      // Build the variants array in the same shape fetchProductVariants() produces
      const optionNames = Array.isArray(product?.options)
        ? product.options.map(o => (o?.name || o)).filter(Boolean)
        : [];

      const variants = Array.isArray(product?.variants) ? product.variants : [];
      const variantsNormalized = variants.map(v => {
        const values = [];
        if (v.option1 && v.option1 !== "Default Title") values.push(v.option1);
        if (v.option2 && v.option2 !== "Default Title") values.push(v.option2);
        if (v.option3 && v.option3 !== "Default Title") values.push(v.option3);
        const vImg = v.featured_image && (v.featured_image.src || v.featured_image);
        return {
          id: v.id,
          available: v.available,
          sku: v.sku || "",
          title: v.title || "",
          image: typeof vImg === "string" ? vImg : "",
          optionNames,
          values,
        };
      });

      // Started from a product card / plain link (the product page always sends
      // variant_title with the choices already made): ask the product's questions
      // in a pop-up — the MAM builder, or the oven options (Color, Fuel Type…).
      if (!params.has("variant_title") && !fwqOvenBuild && !fwqOvenColor && !fwqOvenEngraving && !fwqOvenOptions) {
        render(app);
        if (await openMamBuilder(productObj, variantsNormalized, app)) return;
        if (await openQuoteOptions(productObj, variantsNormalized, app, variantIdParam)) return;
      }

      // Decide what to do based on whether the product has real variants:
      //
      //   - If the product has NO real variants (single-variant product like
      //     a simple accessory), add it directly to the quote at qty 1. There
      //     is nothing for the customer to choose, so making them search for
      //     it again would be pure friction. They can still Remove it.
      //   - If the product HAS real variants, open the variant picker
      //     pre-selected to the variant_id from the URL (or the first
      //     available variant if no variant_id was passed). The customer
      //     confirms by clicking "Add to Quote".
      const firstVals = variantsNormalized[0]?.values || [];
      const firstHasReal = firstVals.some(v => v && !["Default", "Default Title"].includes(v));
      const hasRealChoices = variantsNormalized.length > 1 || firstHasReal;

      if (!hasRealChoices) {
        // Single-variant product: add it straight to the quote.
        const singleVariant = variantsNormalized[0] || null;
        addLineItemFromVariant(productObj, singleVariant);
        await addCompanionLinesFromParams(params);
        console.info("Quote prefill: single-variant product added to quote");
        render(app);
        return;
      }

      // Find the variant from the URL, or fall back to first available
      let targetVariant = null;
      if (variantIdParam) {
        targetVariant = variantsNormalized.find(v => String(v.id) === String(variantIdParam));
      }
      if (!targetVariant) {
        targetVariant = variantsNormalized.find(v => v.available !== false) || variantsNormalized[0];
      }

      if (!targetVariant) {
        console.warn("Quote prefill: no usable variant found");
        return;
      }

      // A MAM build from the product page already chose the exact variant
      // (in-stock unit or special order) — add it directly, no picker.
      // Same when the product page already chose everything (direct=1 — the
      // "Request a Shipping Quote" button): add the exact variant with its
      // color / options and photo, no picker to confirm again.
      if ((fwqOvenBuild || params.get("direct") === "1") && variantIdParam && String(targetVariant.id) === String(variantIdParam)) {
        addLineItemFromVariant(productObj, targetVariant);
        await addCompanionLinesFromParams(params);
        render(app);
        return;
      }

      // A MAM product linked without a build (old link, typed URL): open the
      // builder pop-up instead of the plain variant picker.
      if (!fwqOvenBuild) {
        render(app);
        if (await openMamBuilder(productObj, variantsNormalized, app)) return;
      }

      // Pre-populate selectedOptions based on the target variant
      const selectedOptions = {};
      (optionNames || []).forEach((name, idx) => {
        selectedOptions[name] = targetVariant.values?.[idx] || "";
      });

      // Set the variant picker state so it renders open with this variant pre-selected
      state.variantPicker = {
        product: productObj,
        variants: variantsNormalized,
        optionNames,
        selectedOptions,
        selectedId: targetVariant.id,
      };

      // Add any companion lines (e.g. gas burner) up front so they're visible
      // in the selected-products list; the oven joins when the customer
      // confirms the variant via "Add to Quote".
      await addCompanionLinesFromParams(params);

      // Re-render so the picker appears
      render(app);
    } catch (e) {
      console.warn("Quote prefill: unexpected error", e);
      // Silent failure — customer sees the empty form.
    }
  }

  // ====== SIGNED-IN CUSTOMER ======
  // layout/theme.liquid renders <script id="fwq-customer" type="application/json"> only
  // when a customer is logged in (their name, email, phone and default address). Fill
  // the empty fields from it so returning customers don't retype their details; anything
  // already typed wins. Country/state are matched to the dropdown values (canonical
  // English names); a PR address — stored by Shopify as US + province PR or as country
  // PR — becomes country "Puerto Rico", like the form's own PR option.
  function prefillFromCustomer() {
    let c = null;
    try { c = JSON.parse(document.getElementById("fwq-customer")?.textContent || "null"); } catch { c = null; }
    if (!c) return;
    const a = c.address || {};
    const fill = (key, v) => { if (!state[key] && v) state[key] = String(v).trim(); };
    fill("firstName", c.firstName || a.firstName);
    fill("lastName", c.lastName || a.lastName);
    fill("email", c.email);
    fill("phone", c.phone || a.phone);
    fill("company", a.company);
    if (state.street || state.city || state.zip) return; // address partly typed — leave it alone
    fill("street", a.address1);
    fill("street2", a.address2);
    fill("city", a.city);
    fill("zip", a.zip);
    const isPR = a.countryCode === "PR" || (a.countryCode === "US" && a.provinceCode === "PR");
    const countries = getCountries();
    const match = (list, ...names) => list.find((x) => names.some((n) => n && (x.name === n || x.label === n)));
    if (!state.country) {
      if (isPR) state.country = "Puerto Rico";
      else if (!countries.length) state.country = a.country || "";
      else state.country = match(countries, a.country, a.countryCode === "US" ? "United States" : "")?.name || "";
    }
    if (!state.region && state.country && state.country !== "Puerto Rico") {
      const provinces = (findCountry(state.country)?.provinces || []).map(([name, label]) => ({ name, label }));
      state.region = provinces.length ? (match(provinces, a.province)?.name || "") : (a.province || "");
    }
  }

  // ====== INIT ======
  function init() {
    const app = document.getElementById("fw-quote-app");
    if (!app) return;
    prefillFromCustomer();
    render(app);
    // Run prefill after initial render so the variant picker has a place to mount.
    prefillFromUrl(app);
  }

  document.addEventListener("DOMContentLoaded", init);

  // Product-card "Request a Quote" pop-up (assets/fwo-quote-modal.js) loads this file on
  // demand and mounts the form into its modal, pre-filled from the card link's query string.
  window.FwoQuoteForm = {
    // Resolves once the prefill is done (incl. opening the MAM / oven options pop-up),
    // so the modal can reveal the form and the pop-up together instead of one then the other.
    mount(app, search) {
      prefillFromCustomer();
      render(app);
      return prefillFromUrl(app, search);
    },
    prefetch: prefetchProduct,
  };
})();
